import type { SVGProps } from "react";

import { brandIconA11y } from "@/components/icons/brandIconA11y";

/**
 * Google Cloud brand mark — the four-colour cloud.
 *
 * Exists because the codebase had been standing in `faGoogle` wherever it meant
 * the *cloud provider*. That is the consumer Google "G": it belongs on
 * "Sign in with Google", not on a cloud-credentials row, exactly as the
 * Microsoft four-square belongs on the SSO button rather than on Azure.
 *
 * Full colour on purpose — provider marks are vendor identity, not UI accents,
 * which is why AWS keeps its orange. `currentColor` is not usable (the mark is
 * four fixed brand colours), so unlike the FontAwesome provider icons this one
 * ignores `text-gcp`. Size it with `className="h-4 w-4"`.
 *
 * No gradients, so no id namespacing needed here — contrast with `AzureIcon`.
 */
export function GoogleCloudIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 256 206"
      xmlns="http://www.w3.org/2000/svg"
      {...brandIconA11y(props)}
      className={className}
      {...props}
    >
      <path
        fill="#ea4335"
        d="m170.252 56.819l22.253-22.253l1.483-9.37C153.437-11.677 88.976-7.496 52.42 33.92C42.267 45.423 34.734 59.764 30.717 74.573l7.97-1.123l44.505-7.34l3.436-3.513c19.797-21.742 53.27-24.667 76.128-6.168z"
      />
      <path
        fill="#4285f4"
        d="M224.205 73.918a100.25 100.25 0 0 0-30.217-48.722l-31.232 31.232a55.52 55.52 0 0 1 20.379 44.037v5.544c15.35 0 27.797 12.445 27.797 27.796c0 15.352-12.446 27.485-27.797 27.485h-55.671l-5.466 5.934v33.34l5.466 5.231h55.67c39.93.311 72.553-31.494 72.864-71.424a72.3 72.3 0 0 0-31.793-60.453"
      />
      <path
        fill="#34a853"
        d="M71.87 205.796h55.593V161.29H71.87a27.3 27.3 0 0 1-11.399-2.498l-7.887 2.42l-22.409 22.253l-1.952 7.574c12.567 9.489 27.9 14.825 43.647 14.757"
      />
      <path
        fill="#fbbc05"
        d="M71.87 61.426C31.94 61.663-.237 94.227.001 134.158a72.3 72.3 0 0 0 28.222 56.88l32.248-32.246c-13.99-6.322-20.208-22.786-13.887-36.776s22.786-20.208 36.775-13.888a27.8 27.8 0 0 1 13.887 13.888l32.248-32.248A72.22 72.22 0 0 0 71.87 61.427"
      />
    </svg>
  );
}
